import initialState from './programPaymentTypeInitialState';

export default function programPaymentTypeReducer(state = initialState) {
    return state;
}
